<nav class="navbar navbar-expand-lg">
  <a class="navbar-brand" routerLink="/"></a>
</nav>